import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { NgxFileDropEntry } from 'ngx-file-drop';


@Component({
  standalone: false,
  selector: 'app-file-upload',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss']
})
export class FileUploadDialogComponent {


  documentsToUpload: NgxFileDropEntry | null;

  constructor(
    public dialogRef: MatDialogRef<FileUploadDialogComponent>,
  ) {
  }


  public documentDroped(documents: NgxFileDropEntry[]) {
    for (const droppedDocument of documents) {
      this.documentsToUpload = droppedDocument;
    }
  }

  uploadFile() {
    const fileEntry = this.documentsToUpload?.fileEntry as FileSystemFileEntry;
    fileEntry.file((file: File) => {
      this.dialogRef.close(file);
    });
  }


  removeDroppedDocument() {
    this.documentsToUpload = null;
  }



  onNoClick(): void {
    this.dialogRef.close(false);
  }

}
